
import DecoratorMixin from '../mixin';

export default {
  mixins: [DecoratorMixin],
};
